/* THE MEN THING — AI search in the header.  (GLITCH-FIX build, 15 Jul 2026)
 *  • Tapping the header's existing search icon opens the AI search.
 *  • On scroll (mobile), the header transforms: the logo hides and a search bar
 *    expands in its place; clicking it opens the same AI search.
 *
 *  Two fixes vs the previous version, to kill the "glitch on top":
 *   1. HEIGHT LOCK — hiding the centered logo used to collapse the header
 *      190px → 139px (a 51px jump that yanked the page up). We now (a) hide the
 *      logo with visibility:hidden (keeps its box) AND (b) pin the header's
 *      min-height to its measured height while active, so it can't shrink.
 *   2. HYSTERESIS — a single y>150 threshold let tiny scrolls toggle on/off and
 *      shimmer. Now: turn ON at y>175, OFF at y<110 (dead-band between).
 *
 *  Install: overwrite the existing theme asset `tmt-header-search-test.js` with
 *  this file's contents (Online Store → Themes → Edit code → Assets). No other
 *  change needed — the <script> reference stays the same.
 */
(function () {
  if (window.__tmtHeaderSearch) return;
  window.__tmtHeaderSearch = true;

  var script = document.currentScript || (function () { var s = document.getElementsByTagName("script"); return s[s.length - 1]; })();
  var cfg = (script && script.dataset) || {};
  var BASE = cfg.base || "/apps/ai-search";
  var PLACEHOLDER = cfg.placeholder || "Search for chains, bracelets, rings…";

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // ── modal with the full AI search widget ──
  var css =
    ".tmt-hbar{position:absolute;top:50%;left:60px;right:120px;transform:translateY(-50%);display:none;align-items:center;gap:9px;height:40px;padding:0 14px;border:1px solid #e3e3e3;border-radius:21px;background:#fff;color:#333;cursor:text;z-index:6;}" +
    ".tmt-hbar:hover{border-color:#c9c9c9;}" +
    ".tmt-hbar svg{width:18px;height:18px;flex:0 0 auto;opacity:1;color:#666;}" +
    ".tmt-hbar span{font-size:14px;opacity:1;color:#777;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "header.header.tmt-srch .tmt-hbar{display:flex;}" +
    // FIX 1: hide the logo with visibility (keeps its layout box) instead of
    // display:none (which removed the row and collapsed the header 51px).
    "header.header.tmt-srch .header__heading,header.header.tmt-srch .header__heading-link,header.header.tmt-srch .header__heading-logo-wrapper,header.header.tmt-srch .header__heading-logo{visibility:hidden !important;}" +
    "header.header.tmt-srch details-modal.header__search{display:none;}" +
    /* modal */
    ".tmt-ov{position:fixed;inset:0;z-index:2147483001;display:none;align-items:flex-start;justify-content:center;background:rgba(15,15,17,.55);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);padding:4vh 16px 16px;}" +
    ".tmt-ov.open{display:flex;}" +
    ".tmt-pan{position:relative;width:min(920px,96vw);max-height:92vh;display:flex;flex-direction:column;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.4);}" +
    ".tmt-hd{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid #eee;flex:0 0 auto;color:#111;}" +
    ".tmt-hd b{font:700 16px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;}" +
    ".tmt-x{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border:0;border-radius:8px;background:#f3f3f3;color:#333;cursor:pointer;}.tmt-x svg{width:18px;height:18px;}" +
    ".tmt-bd{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:12px 16px 16px;}" +
    ".tmt-fr{width:100%;border:0;display:block;min-height:420px;}" +
    "@media(max-width:600px){.tmt-ov{padding:0;}.tmt-pan{width:100vw;max-height:100vh;height:100vh;border-radius:0;}.tmt-hbar{left:50px;right:96px;}}";
  var style = document.createElement("style"); style.textContent = css; document.head.appendChild(style);

  var ov = document.createElement("div");
  ov.className = "tmt-ov"; ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "AI product search");
  ov.innerHTML = '<div class="tmt-pan"><div class="tmt-hd"><b>AI Powered Search</b><button class="tmt-x" aria-label="Close">' + CLOSE + '</button></div><div class="tmt-bd"><iframe class="tmt-fr" title="AI product search"></iframe></div></div>';
  var frame = ov.querySelector(".tmt-fr");
  function focusInput() { try { frame.contentWindow.document.querySelector(".aisearch__input").focus({ preventScroll: true }); } catch (e) {} }
  function open() {
    preloadFrame();
    ov.classList.add("open"); document.documentElement.style.overflow = "hidden";
    focusInput();
    [30, 120, 300, 600].forEach(function (t) { setTimeout(focusInput, t); });
  }
  function close() { ov.classList.remove("open"); document.documentElement.style.overflow = ""; }
  ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
  ov.querySelector(".tmt-x").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && ov.classList.contains("open")) close(); });

  // ── intercept the theme's existing header search icon (top state) ──
  var TRIGGER = "details-modal.header__search summary, summary.header__icon--search, .header__icon--search, #Details-search summary";
  if (cfg.selectors) TRIGGER += "," + cfg.selectors;
  function hit(e) { return e.target && e.target.closest ? e.target.closest(TRIGGER) : null; }
  document.addEventListener("click", function (e) { if (hit(e)) { e.preventDefault(); e.stopImmediatePropagation(); open(); } }, true);
  document.addEventListener("keydown", function (e) { if ((e.key === "Enter" || e.key === " ") && hit(e)) { e.preventDefault(); e.stopImmediatePropagation(); open(); } }, true);

  // ── on-scroll header transform: hide logo, expand the search bar in place ──
  var header = document.querySelector("header.header");
  var bar = document.createElement("div");
  bar.className = "tmt-hbar"; bar.setAttribute("role", "button"); bar.setAttribute("tabindex", "0"); bar.setAttribute("aria-label", "Open AI search");
  bar.innerHTML = ICON + "<span>" + PLACEHOLDER + "</span>";
  bar.addEventListener("click", open);
  bar.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } });

  function place() {
    if (!header) return;
    var hr = header.getBoundingClientRect();
    var menu = header.querySelector(".header__icon--menu") || header.querySelector("header-drawer summary") || header.querySelector("header-drawer");
    var icons = header.querySelector(".header__icons");
    var L = menu ? (menu.getBoundingClientRect().right - hr.left + 12) : 56;
    var R = icons ? (hr.right - icons.getBoundingClientRect().left + 12) : 110;
    bar.style.left = Math.max(12, L) + "px";
    bar.style.right = Math.max(12, R) + "px";
    var ref = icons || menu;
    if (ref) {
      var rr = ref.getBoundingClientRect();
      var center = rr.top - hr.top + rr.height / 2;
      if (hr.height > 110) center = Math.max(center, 36);
      bar.style.top = center + "px";
    }
  }
  var on = false;
  function setScrolled(v) {
    if (!header || v === on) return; on = v;
    if (v) {
      // FIX 1 (belt-and-suspenders): measure the header's natural height BEFORE
      // hiding the logo and pin it as min-height, so the header can never shrink
      // even on themes where the logo is positioned oddly.
      var h = header.getBoundingClientRect().height;
      if (getComputedStyle(header).position === "static") header.style.position = "relative";
      header.style.minHeight = Math.round(h) + "px";
      header.classList.add("tmt-srch");
      place(); requestAnimationFrame(place); setTimeout(place, 50);
    } else {
      header.classList.remove("tmt-srch");
      header.style.position = "";
      header.style.minHeight = "";
    }
  }
  function isMobile() { try { return window.matchMedia("(max-width: 989px)").matches; } catch (e) { return window.innerWidth < 990; } }
  function onScroll() {
    if (!isMobile()) { setScrolled(false); return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || (document.scrollingElement ? document.scrollingElement.scrollTop : 0) || 0;
    // FIX 2: hysteresis — ON above 175, OFF below 110. The dead-band stops the
    // transform toggling (and shimmering) when the shopper hovers near threshold.
    if (!on && y > 175) setScrolled(true);
    else if (on && y < 110) setScrolled(false);
  }

  function preloadFrame() { if (!frame.getAttribute("src")) frame.src = BASE + "/widget?focus=1"; }
  function start() {
    document.body.appendChild(ov);
    if (document.readyState === "complete") setTimeout(preloadFrame, 1500);
    else window.addEventListener("load", function () { setTimeout(preloadFrame, 1500); });
    if (header) { header.appendChild(bar); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { onScroll(); if (on) place(); }, { passive: true });
    onScroll();
  }
  if (document.body) start(); else document.addEventListener("DOMContentLoaded", start);
})();